jQuery(window).bind("pageshow", function(event) {
  jQuery(".preloader").hide();
});

jQuery(document).ready(function() {

  function checkPlan() {
    var albums = jQuery('input[name="albums-per-month"]:checked');
    var payment = jQuery('input[name="payment"]:checked');
    var discount = jQuery('input[name="discount"]:checked');
    var className = '';
    
    if ( albums.length ) {
      className = albums.val();
    }
    
    if ( payment.length ) {
      className += '_' + payment.val();
    }
    
    if ( discount.length ) {
      className += '_' + discount.data('value');
    }
    //console.log(className);
    
    var subscription = jQuery('input[name="subscription"].'+className);
    if ( subscription.length ) {
      subscription.click();
    }
    
  }
  
  jQuery(document).on('click','.plan-block input[type="radio"], .checkbox input[type="checkbox"]', function(e){
    var $this = jQuery(this);
    var checkbox = jQuery('.checkbox');
    var payment = jQuery('input[name="payment"]:checked');
    var discount = jQuery('input[name="discount"]');   
    if ( ( payment.attr('name') == 'payment' ) && ( payment.val() == 'monthly' ) ) {
       checkbox.show();
    } else {
      checkbox.hide();
      discount.prop( "checked", false );
    }
    checkPlan();
  });
  
  jQuery(document).on('click','input[name="discount"]', function(e){ 
    if ($(this).is(":checked")) {
       $(".welcome-pack").show();
    } else {
       $(".welcome-pack").hide();
    }
  });
  
  jQuery(document).on('change','input[name="subscription"]', function(e){
    var $this = jQuery(this);
    var button = jQuery('button[type="submit"]');
    var amount = jQuery('.amount');
    var free_pack = amount.find('.welcome-pack');
    var free_pack_id = $this.attr('data-free_pack');
    var free_pack_text = $this.attr('data-free_pack_text');
    var price_line1 = $this.attr('data-price_line1');
    var price_line2 = $this.attr('data-price_line2');
    var price_line3 = $this.attr('data-price_line3');
    //console.log($this);
    if ( $this.length ) {
      amount.find('.price-line1').html(price_line1);
      amount.find('.price-line2').html(price_line2);
      amount.find('.price-line3').html(price_line3);
      if ( (typeof free_pack_id !== "undefined") && (typeof free_pack_id !== "null") && ( free_pack_id ) ) {
        if ( (typeof free_pack_text !== "undefined") && (typeof free_pack_text !== "null") ) {
          free_pack.find('em').html(free_pack_text);
          free_pack.show();
        } else {
          free_pack.hide();
        }
      } else {
        free_pack.hide();
      }
      amount.show();
      button.css('opacity', '1');
      button.removeAttr('disabled');
    } else {
      amount.hide();
      free_pack.hide();
      amount.find('.price-line').empty();
      button.css('opacity', '0.5');
      button.attr('disabled', 'disabled');
    }
  });
  
  jQuery(document).on('click','button[type="submit"]', function(e){
    e.preventDefault();
    var subscription = jQuery('input[name="subscription"]:checked');
    if ( (typeof subscription !== "undefined") && (typeof subscription !== "null") ) {
      
      var variantId = subscription.val();
      var sell_plan = subscription.attr('data-sell_plan');
      var free_pack = subscription.attr('data-free_pack');
      
      if ( free_pack ) {
        var promo_data = {
          "id": free_pack,
          "quantity": 1
        };
        
      }
      
      if ( variantId && sell_plan ) {
        
        jQuery('.preloader').show();
        
        var product_data = {
          "id": variantId,
          "quantity": 1,
          "selling_plan": sell_plan,
          "attributes": {
            "planpage": 1
          }
        };
        
        jQuery.ajax({
          type: "POST",
          url: '/cart/clear.js',
          dataType: 'json',
          success: function(){
            jQuery.ajax({
              type: "POST",
              url: "/cart/add.js",
              data: product_data,
              dataType: "json",
              success: function (response) {
                if ( promo_data ) {
                  jQuery.ajax({
                    type: "POST",
                    url: "/cart/add.js",
                    data: promo_data,
                    dataType: "json",
                    success: function (response) {
                      window.location.href = '/checkout';
                    },
                  });
                } else {
                  window.location.href = '/checkout';
                }
              }
            });
          }
        });
      }
      
    }
  });
  
});